// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"B6-z","yourQuestionLabel":"C6-z","notAuthedMessage":"D6-z","form":"E6-z","textarea":"F6-z","error":"G6-z","disabled":"H6-z","edited":"I6-z","submit":"J6-z"};